import { render, staticRenderFns } from "./CriterionComparativeTable.vue?vue&type=template&id=08f4aa89&scoped=true&"
import script from "./CriterionComparativeTable.vue?vue&type=script&lang=js&"
export * from "./CriterionComparativeTable.vue?vue&type=script&lang=js&"
import style0 from "./CriterionComparativeTable.vue?vue&type=style&index=0&id=08f4aa89&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f4aa89",
  null
  
)

export default component.exports